import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore, QueryRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

import { RoomViewModel } from 'src/common/models';

import { GalleryTriggerButton } from './gallery-trigger';
import { RoomInfoDialog } from 'components/infosite/rooms-and-rates/room-info-dialog';

export interface DialogTriggerProps {
  analytics?: AnalyticsStore;
  className?: string;
  clickHandler?: () => void;
  id?: string;
  queryParam: string;
  position: string;
  room: RoomViewModel;
  routeStore?: RouteStore;
  trackingRfrr?: string;
  triggerId?: string;
  triggerMessage?: string;
}

export interface RoomInfoDialogProps {
  excludeReserveButton?: boolean;
  excludePriceBreakDownLink?: boolean;
  position: string;
  room: RoomViewModel;
}

type InfoDialogTriggerProps = DialogTriggerProps & RoomInfoDialogProps;

@inject('analytics', 'routeStore')
@observer
export class DialogTrigger extends React.Component<InfoDialogTriggerProps> {
  private dialogTriggerRef;

  private dialogCloseCallback = () => {
    const focus = this.dialogTriggerRef?.focus;
    const goBack = this.props?.routeStore?.goBack;

    if (typeof goBack === 'function') this.props.routeStore.goBack();
    if (typeof focus === 'function') this.dialogTriggerRef.focus();
  };

  public render() {
    const {
      analytics,
      className,
      clickHandler,
      id,
      position,
      queryParam,
      room,
      routeStore,
      trackingRfrr,
      triggerId,
      triggerMessage,
    } = this.props;

    const dialogTriggerRef = ref => (this.dialogTriggerRef = ref);

    const query = routeStore.mergeQueryString(routeStore.search, { pwaDialog: queryParam });

    const galleryTriggerButtonProps = {
      clickHandler,
      displayImageCountMessage: triggerMessage,
      galleryTriggerRef: dialogTriggerRef,
      id,
      linkName: 'Open Room Gallery dialog',
      pathname: routeStore.pathname,
      query,
      trackingRfrr,
    };

    return (
      <div className={`gallery-trigger ${className || ''}`}>
        <GalleryTriggerButton {...galleryTriggerButtonProps} />
        <QueryRoute query={{ pwaDialog: queryParam }}>
          <Layer id={triggerId} onDismiss={this.dialogCloseCallback}>
            <RoomInfoDialog
              action={this.dialogCloseCallback}
              analytics={analytics}
              position={position}
              room={room}
              trackingRfrr={trackingRfrr}
              routeStore={routeStore}
            />
          </Layer>
        </QueryRoute>
      </div>
    );
  }
}
